import { IconButton } from "@chakra-ui/react";
import React, { Ref, useState } from "react";
import { AiTwotoneEye, AiTwotoneEyeInvisible } from "react-icons/ai";

import { OFInput, OFInputProps } from "./OFInput";

type Props = OFInputProps & {
  eyeColor: string;
};

export const OFInputPassword = React.forwardRef(
  (
    // rightIcon is not used, because we override it
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    { rightIcon, ...props }: Props,
    ref: Ref<HTMLInputElement>
  ) => {
    const [showPassword, setShowPassword] = useState(false);
    return (
      <OFInput
        type={showPassword ? "text" : "password"}
        rightIcon={
          <IconButton
            _hover={{
              bg: "transparent"
            }}
            _active={{
              bg: "transparent"
            }}
            bg="transparent"
            disabled={!!props.isDisabled}
            onClick={() => setShowPassword(!showPassword)}
            aria-label="eye"
            background="none"
            color={props.eyeColor}
            fontSize="1.375rem"
            icon={showPassword ? <AiTwotoneEyeInvisible /> : <AiTwotoneEye />}
          />
        }
        {...props}
        ref={ref}
      />
    );
  }
);
